import { render, staticRenderFns } from "./@SetupModule.vue?vue&type=template&id=0e73c04d&"
import script from "./@SetupModule.vue?vue&type=script&lang=js&"
export * from "./@SetupModule.vue?vue&type=script&lang=js&"
import style0 from "./@SetupModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports